import {apiActionImproved} from "@/api.ts";
import {Spinner} from "@heroui/react";
import {addToast} from "@heroui/toast";
import {createFileRoute, useParams} from '@tanstack/react-router'
import {useEffect} from "react";

export const Route = createFileRoute('/public/tournaments/$tournament_uid/applications/$application_uid/pay-entry-fee/')({
    component: RouteComponent,
})

function RouteComponent() {
    const params = useParams({strict: false}) as { application_uid: string };

    useEffect(() => {
        async function redirectToCheckout() {
            // ?for=partner → the partner pays their own per-player share via a separate checkout.
            const forPartner = new URLSearchParams(window.location.search).get('for') === 'partner';
            // ?checkout=divisions → the checkout of the registration page: the fee of the division
            // entered, and the processing fee the organizer passes on. The link the WhatsApp bot sends.
            const asRegistered = new URLSearchParams(window.location.search).get('checkout') === 'divisions';
            const res = asRegistered && !forPartner
                ? await apiActionImproved('stripe-prepare-enroll-divisions-payment' as any, {application_uids: [params.application_uid]})
                : await apiActionImproved((forPartner ? 'stripe-prepare-partner-entry-payment' : 'stripe-prepare-enroll-payment') as any, {
                    application_uid: params.application_uid,
                });

            if (res.error || !res.redirect_url) {
                addToast({
                    title: res.error || 'Payment cannot be accepted right now. Please try again later.',
                    color: 'danger',
                });
                return;
            }

            document.location.href = res.redirect_url;
        }

        redirectToCheckout();
    })
    return <div className="flex flex-col items-center justify-center py-12 space-y-4">
        <Spinner size="lg" />
        <p className="text-lg text-default-600">Redirecting to checkout page...</p>
    </div>
}
